import type { DocumentElement } from '#@/shared/types';

import type { GenericTooltipProps } from './GenericTooltip';
import GenericTooltip from './GenericTooltip';
import type { TooltipSectionProps } from './TooltipSection';
import TooltipSection from './TooltipSection';

export type TooltipProps<TriggerElement> = Omit<
  GenericTooltipProps<TriggerElement>,
  'renderContent'
> &
  Omit<TooltipSectionProps, 'closeTooltip'>;

const Tooltip = <TriggerElement extends DocumentElement>({
  title,
  bodyText,
  actionText,
  action,
  icon,
  actions,
  ...props
}: TooltipProps<TriggerElement>) => (
  <GenericTooltip<TriggerElement>
    {...props}
    renderContent={({ closeTooltip }) => (
      <TooltipSection
        icon={icon}
        title={title}
        bodyText={bodyText}
        actionText={actionText}
        action={action}
        actions={actions}
        closeTooltip={closeTooltip}
      />
    )}
  />
);

export default Tooltip;
